.picker {
  border: 0;
  margin: 2rem 0 0;
  padding: 0;
  min-width: 0;
}

.legend {
  padding: 0;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.item {
  margin-top: 0.5rem;
}

.label {
  display: flex;
  gap: 0.75rem;
  align-items: flex-start;
  background-color: white;
  border: 1px solid var(--color-muted);
  border-left: 4px solid var(--color-muted);
  border-radius: 0.3rem;
  cursor: pointer;
  padding: 0.75rem 1rem;
}

.labelSelected {
  border-color: var(--color-cta);
  border-left-color: var(--color-primary);
}

.label:has(.checkbox:disabled) {
  cursor: not-allowed;
  opacity: 0.6;
}

.checkbox {
  margin-top: 0.3rem;
  flex: 0 0 auto;
}

.body {
  display: block;
  min-width: 0;
}

.quote {
  display: block;
  font-style: italic;
  white-space: pre-wrap;
}

.meta {
  display: block;
  margin-top: 0.5rem;
  color: var(--color-text-muted);
  font-size: 0.875rem;
}

.status {
  margin-top: 0.5rem;
  color: var(--color-text-muted);
  font-size: 0.875rem;
}
